export const rootAreaId = "root";
export const rootZone = "default-zone";
export const rootDroppableId = `${rootAreaId}:${rootZone}`;
